

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// activateLastTier
// ACTIVATELASTTIER
const ACTIVATELASTTIER= createAsyncThunk(
  "activateLastTier/activateLastTier",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const activateLastTierSlice = createSlice({
  name: "activateLastTierSlice",
  initialState: {
    activateLastTier: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfactivateLastTier: (state) => {
        state.activateLastTier.loading = false
        state.activateLastTier.error = false
        state.activateLastTier.data = []
        state.activateLastTier.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ACTIVATELASTTIER.fulfilled, (state, action) => {
      state.activateLastTier = {
        ...state.activateLastTier,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ACTIVATELASTTIER.pending, (state, action) => {
      state.activateLastTier = {
        ...state.activateLastTier,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ACTIVATELASTTIER.rejected, (state, action) => {
      state.activateLastTier = {
        ...state.activateLastTier,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const activateLastTierAction = {
    ACTIVATELASTTIER,
};

export { activateLastTierAction };
export default activateLastTierSlice.reducer;
export const {setInitialStateOfactivateLastTier} = activateLastTierSlice.actions
